import React, { Fragment } from 'react';
import './CompText.css';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';


const CompText = (props) => {


  const screenedFunds = useSelector(state => state.params.screenedFunds)
  const hasModels = screenedFunds.some(fund => fund.type === 'model');

  const keyMetrics = () => {
    return (
      <Fragment>
        <div className='introCopy'>{i18n.t('fund-info')}</div>
        <div className='introCopy'>{i18n.t('comp-holdings')}</div>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf2')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-bps')}</div>
        <div className='introCopy'>
          Correlation: Statistical measure of how two sets of returns move in relation to each other. Correlation coefficients range from -1 to 1. A correlation of 1 means the two subjects of analysis move in lockstep with each other. A correlation of -1 means the two subjects of analysis have moved in exactly the opposite direction.
        </div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const chars = () => {
    return (
      <Fragment>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-bps')}</div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-fund')}:</span>
          <ul>
            <li>{i18n.t('comp-fund1')}</li>
            <li>{i18n.t('comp-fund2')}</li>
            <li>{i18n.t('comp-fund3')}</li>
            <li>{i18n.t('comp-fund4')}</li>
            <li>{i18n.t('comp-fund5')}</li>
            <li>{i18n.t('comp-fund6')}</li>
            <li>{i18n.t('comp-fund7')}</li>
            <li>{i18n.t('comp-fund8')}</li>
            <li>{i18n.t('comp-fund9')}</li>
            <li>{i18n.t('comp-fund10')}</li>
            <li>{i18n.t('comp-fund11')}</li>
            <li>{i18n.t('comp-fund13')}</li>
            <li>{i18n.t('gross-buyback-yield')}</li>
          </ul>
        </div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-market')}:</span>
          {i18n.t('comp-market1')}
        </div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const performance = () => {
    return (
      <Fragment>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf2')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const exposures = () => {
    return (
      <Fragment>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-bps')}</div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-market')}: </span>
          {i18n.t('comp-market1')}

        </div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{'Developed Markets'}: </span>
          {i18n.t('Developed Markets')}

        </div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{'Emerging Markets'}: </span>
          {i18n.t('Emerging Markets')}
        </div>
        <div className='introCopy'>
          <span style={{ fontWeight: 'bold' }}>{'State Owned Enterprises'}: </span>
          {i18n.t('soe')}
        </div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const factors = () => {
    return (
      <Fragment>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf2')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-bps')}</div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const details = () => {
    return (
      <Fragment>
        <div className='introCopyProspectus'>{i18n.t('competitor-funds')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-perf2')}</div>
        <div className='introCopyProspectus'>{i18n.t('stand-perf')}</div>
        <div className='introCopyProspectus'>{i18n.t('comp-prospect')}</div>
        <div className='introCopy'>{i18n.t('comp-bps')}</div>
        <div className='introCopy'>{i18n.t('comp-info')}</div>
        {hasModels && <div className='introCopy'>{i18n.t('comp-model')}</div>}
      </Fragment>
    );
  }

  const esg = () => {
    return (
      <Fragment>
        <div className='introCopy'>{i18n.t('esg-source')}</div>
      </Fragment>
    );
  }

  const compgics = () => {
    return <div className='introCopy'>{i18n.t('comp-gics')}</div>;
  }

  const compfund = () => {
    return (
      <div className='introCopy'>
        <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-fund')}:</span>
        <ul>
          <li>{i18n.t('comp-fund1')}</li>
          <li>{i18n.t('comp-fund2')}</li>
          <li>{i18n.t('comp-fund3')}</li>
          <li>{i18n.t('comp-fund4')}</li>
          <li>{i18n.t('comp-fund5')}</li>
          <li>{i18n.t('comp-fund6')}</li>
          <li>{i18n.t('comp-fund7')}</li>

        </ul>
      </div>
    );
  }

  const compmarket = () => {
    return (
      <div className='introCopy'>
        <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-market')}:</span>
        {i18n.t('comp-market1')}
      </div>
    );
  }

  const compmomentum = () => {
    return (
      <div className='introCopy'>
        <span style={{ fontWeight: 'bold' }}>{i18n.t('comp-momentum-data')}:</span>
        {i18n.t('comp-momentum1')}
      </div>
    );
  }

  const { pane } = props;
    
  if (pane === 'KeyMetrics') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '15px', paddingLeft: '0px', paddingright: '0px' }}>
        {keyMetrics()}
      </div>
    );
  } else if (pane === 'Chars') {
    return (
      <div>
        <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
          {chars()}
        </div>
        <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
          {compmomentum()}
        </div>
      </div>
    );
  } else if (pane === 'Exposures') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
        {exposures()}
      </div>
    );
  } else if (pane === 'Performance') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
        {performance()}
      </div>
    );
  } else if (pane === 'Details') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
        {details()}
      </div>
    );
  } else if (pane === 'Factors') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
        {factors()}
      </div>
    );
  } else if (pane === 'esg') {
    return (
      <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
        {esg()}
      </div>
    );
  }
  else {
    return (
      <div>
        <div className='comp-text col-md-12' style={{ marginTop: '20px', paddingLeft: '0px', paddingright: '0px' }}>
          {compfund()}
        </div>

      </div>
    );
  }
}

export default CompText